import { useMemo, createElement } from "react";
import { SearchProvider, SearchableItem } from "@/hooks/search/usePageSearch";
import { useAdminClients } from "@/hooks/admin/useAdminClients";
import BusinessIcon from "@mui/icons-material/Business";

export const useClientsSearchProvider = (): SearchProvider => {
  const { clients, isLoading } = useAdminClients();

  const searchableItems = useMemo((): SearchableItem[] => {
    if (!clients || isLoading) {
      return [];
    }

    return clients.map((client) => ({
      id: `client-${client.id}`,
      title: client.companyName,
      segment: "clients",
      path: `/admin/client-management/${client.id}`,
      icon: createElement(BusinessIcon),
      description: `Client - ${client.email || "No email"}`,
      category: "Clients",
      type: "client",
    }));
  }, [clients, isLoading]);

  return {
    getItems: () => searchableItems,
    isLoading,
  };
};
